import api from '@/services/api';

const ENTITY_ENDPOINT = 'tipo-extrusion';

export class ExtrusionTipoService {
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }
}

export default ExtrusionTipoService;
